<template>
  <b-overlay :show="isLoading" rounded="sm">
    <div v-if="pageUrls !== null">
      <!-- Table Container Card -->
      <b-card class="mb-0">
        <div class="my-2">
          <!-- Table Top -->
          <b-row>
            <transition name="fade">
              <b-col
                  cols="12"
                  class=""
              >
                <b-row class="">
                  <b-col cols="12" class="">
                    <b-row class="">
                      <b-col cols="12">
                        <h1 class="">Add Url</h1>
                        <b-form>
                          <b-row>
                            <b-col cols="6">
                              <b-form-group label="Old url" label-for="name">
                                <b-form-input
                                    placeholder="product"
                                    v-model="defaultCreateData.oldUrl"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col cols="6">
                              <b-form-group label="Destination url" label-for="name">
                                <b-form-input
                                    placeholder="/blog"
                                    v-model="defaultCreateData.destinationUrl"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col cols="6">
                              <b-form-group label="Status code" label-for="name">
                                <b-form-input
                                    placeholder="301"
                                    v-model="defaultCreateData.statusCode"
                                />
                              </b-form-group>
                            </b-col>
<!--                            <b-col cols="6">-->
<!--                              <b-form-group label="Index option" label-for="name">-->
<!--                                <b-form-checkbox-->
<!--                                    v-model="defaultCreateData.isEnable"-->
<!--                                    switch-->
<!--                                />-->
<!--                              </b-form-group>-->
<!--                            </b-col>-->
                          </b-row>
                        </b-form>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12">
                    <b-button
                        @click="createPageUrl"
                        variant="success"
                    >
                      <span class="text-nowrap">Add Url</span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </transition>
          </b-row>
          <h2 class="my-2">Page urls</h2>
        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="pageUrls"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="No items available"
        >
          <!-- Column: delete -->

          <template #cell(isEnable)="data">
            <feather-icon
                v-if="!data.item.isEnable"
                icon="XCircleIcon"
                size="20"
                varient="danger"
                class="text-danger"
            />
            <feather-icon
                v-if="data.item.isEnable"
                icon="CheckCircleIcon"
                size="20"
                varient="success"
                class="text-success"
            />
          </template>
          <template #cell(actions)="data">
            <div class="d-flex align-items-center" style="gap: 2rem">
              <div
                  class="cursor-pointer"
                  v-b-modal.modal-edit
                  @click="renderEditModal(data.item)"
              >
                <feather-icon size="20" icon="EditIcon" class="text-primary"/>
              </div>
              <div
                class="cursor-pointer"
                v-b-modal.modal-delete
                @click="renderDeleteModal(data.item)"
              >
                <feather-icon size="20" icon="TrashIcon" class="text-danger" />
              </div>
            </div>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12">
              <!-- pagination -->
              <div
                  class="my-2 d-flex align-items-center justify-content-center"
              >
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    first-number
                    align="center"
                    last-number
                    prev-class="prev-item"
                    next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <!-- Delete Modal Start -->
    <b-modal
        id="modal-delete"
        centered
        ok-variant="danger"
        title="Delete a category"
        ok-title="Delete"
        cancelTitle="Dismiss"
        @ok="deletePageUrl"
    >
      <span>Are you sure you want to remove this item?</span>
    </b-modal>
    <!-- Delete Modal End -->

    <!-- Create Modal with mainId Start -->
    <b-modal
        v-if="tempPage"
        id="modal-edit"
        centered
        ok-variant="success"
        title="Edit Url"
        ok-title="Edit"
        @cancel="setDefaultData"
        @ok="editPageUrl"
        cancelTitle="Dismiss"
    >
      <b-container fluid>
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Old url" label-for="name">
                <b-form-input
                    placeholder="/product"
                    v-model="tempPage.oldUrl"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Destination url" label-for="name">
                <b-form-input
                    placeholder="/product"
                    v-model="tempPage.destinationUrl"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Status code" label-for="name">
                <b-form-input
                    placeholder="301"
                    v-model="tempPage.statusCode"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Index option" label-for="name">
                <b-form-checkbox
                    v-model="tempPage.isEnable"
                    switch
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </b-modal>
    <!-- Create Modal with mainId End -->
  </b-overlay>
</template>

<script>
import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormRow,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal, BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import LanguagePicker from "../../../components/utils/LanguagePicker.vue";
import AddEditDeleteButton from "@/views/components/utils/AddEditDeleteButton.vue";
import {GetAllLangs} from "@/libs/Api/Language";
import {
  SeoRedirectManagementDelete,
  SeoRedirectManagementGetAll,
  SeoRedirectManagementUpdateSeoData
} from "@/libs/Api/SeoRedirectManagement";

export default {
  name: "GetAll",
  title: "Redirects",
  data() {
    return {
      languageList:[],
      isLoading: false,
      pageUrls: null,
      totalCount: null,
      addNewCategory: false,
      tempPage: null,
      currentPage: 1,
      perPage: 10,
      myTableColumns: [
        {
          key: "id",
          label: "Id",
        },
        {
          key: "oldUrl",
          label: "old Url",
        },
        {
          key: "destinationUrl",
          label: "destination Url",
        },
        {
          key: "statusCode",
          label: "status code",
        },
        {
          key: "isEnable",
          label: "Index option",
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],
      defaultCreateData: {
        oldUrl: "",
        destinationUrl: "",
        statusCode: null,
        isEnable: true
      },
    };
  },
  watch: {
    currentPage: {
      handler(val) {
        this.getAllData();
      },
    },
  },
  async created() {
    await this.getAllData();
  },
  methods: {
    setDefaultData() {
      this.defaultCreateData = {
        isDeleted: false,
        id: 0,
        oldUrl: "",
        destinationUrl: "",
        statusCode: null,
        isEnable: true
      };
    },
    async getAllData() {
      try {
        this.isLoading = true;
        let _this = this;

        let seoRedirectManagementGetAll = new SeoRedirectManagementGetAll(_this);
        seoRedirectManagementGetAll.setRequestParam({
          count: _this.perPage,
          pageNumber: _this.currentPage,
        });
        await seoRedirectManagementGetAll.fetch(
            function (response) {
              if (response.isSuccess) {
                _this.pageUrls = response.data.data;
                _this.totalCount = response.data.totalCount;
              }
            },
            function (content) {
              console.log(content);
            }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async createPageUrl() {
      try {
        this.isLoading = true;
        let _this = this;
        let seoRedirectManagementUpdateSeoData = new SeoRedirectManagementUpdateSeoData(_this);
        seoRedirectManagementUpdateSeoData.setRequestParams(_this.defaultCreateData);
        await seoRedirectManagementUpdateSeoData.fetch(
            function (response) {
              if (response.isSuccess) {
                _this.$toast({
                  component: ToastificationContent,
                  position: "bottom-center",
                  props: {
                    title: "Operation Was Successful",
                    icon: "CheckIcon",
                    variant: "success",
                    text: "Category Created Successfully",
                  },
                });
                _this.defaultCreateData = {
                  isDeleted: false,
                  id: 0,
                  oldUrl: "",
                  destinationUrl: "",
                  statusCode: null,
                  isEnable: true
                };
                _this.getAllData();
              }
            },
            function (error) {
              console.log(error);
            }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async editPageUrl() {
      try {
        this.isLoading = true;
        let _this = this;
        let seoRedirectManagementUpdateSeoData = new SeoRedirectManagementUpdateSeoData(_this);
        seoRedirectManagementUpdateSeoData.setRequestParams(_this.tempPage);
        await seoRedirectManagementUpdateSeoData.fetch(
            function (response) {
              if (response.isSuccess) {
                _this.$toast({
                  component: ToastificationContent,
                  position: "bottom-center",
                  props: {
                    title: "Operation Was Successful",
                    icon: "CheckIcon",
                    variant: "success",
                    text: "Category Created Successfully",
                  },
                });
                _this.tempPage = null;
                _this.getAllData();
              }
            },
            function (error) {
              console.log(error);
            }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async deletePageUrl() {
      try {
        this.isLoading = true;
        let _this = this;

        let seoRedirectManagementDelete = new SeoRedirectManagementDelete(_this);
        seoRedirectManagementDelete.setRequestParams({id:_this.tempPage.id});
        await seoRedirectManagementDelete.fetch(
            function (response) {
              if (response.isSuccess) {
                _this.$toast({
                  component: ToastificationContent,
                  position: "bottom-center",
                  props: {
                    title: "Operation Was Successful",
                    icon: "CheckIcon",
                    variant: "success",
                    text: "Category Deleted Successfully",
                  },
                });
                _this.tempPage = null;
                _this.getAllData();
              }
            },
            function (error) {
              console.log(error);
            }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    renderDeleteModal(page) {
      this.tempPage = JSON.parse(JSON.stringify(page));
      this.$bvModal.show("modal-delete");
    },
    renderEditModal(page) {
      this.tempPage = JSON.parse(JSON.stringify(page));
      this.$bvModal.show("modal-edit");
    },
  },
  components: {
    BFormCheckbox,
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BFormRow,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,
    LanguagePicker,
    vSelect,
    AddEditDeleteButton,
  },
};
</script>

<style scoped></style>
